import GwayAgenteService from "@/services/GwayAgenteService";

export const gwayAgente = {
  namespaced: true,
  state: {},
  actions: {
    gerarCodigo({ commit }, idDestino) {
      return GwayAgenteService.gerarCodigo(idDestino).then(
        (response) => Promise.resolve(response.Data),
        (error) => Promise.reject(error.response.data)
      );
    },
    gerarCodigoDestinoFixo({ commit }, destino) {
      return GwayAgenteService.gerarCodigoDestinoFixo(
        destino.modulo,
        destino.codigo
      ).then(
        (response) => Promise.resolve(response.Data),
        (error) => Promise.reject(error.response.data)
      );
    },
    getDestinosFixosWeb({ commit }, modulo) {
      return GwayAgenteService.getDestinosFixosWeb(modulo).then(
        (response) => Promise.resolve(response.Data || []),
        (error) => Promise.reject(error.response.data)
      );
    },
    getDestinosWeb({ commit }, payload) {
      return GwayAgenteService.getDestinosWeb().then(
        (response) => {
          const query = new URLSearchParams(
            String(payload || "").replace(/^\?/, "")
          );
          let destinos = response.Data || [];
          const filtro = query.get("$filter") || "";
          const pesquisa = filtro.match(/contains\(local,\s*'(.+)'\)/i);

          if (pesquisa) {
            const termo = pesquisa[1].replace(/''/g, "'").toUpperCase();
            destinos = destinos.filter((item) =>
              String(item.local || "")
                .toUpperCase()
                .includes(termo)
            );
          }

          const ordenacao = (query.get("$orderby") || "local asc").split(/\s+/);
          const campo = ordenacao[0];
          const direcao = ordenacao[1] === "desc" ? -1 : 1;
          destinos.sort(
            (a, b) =>
              String(a[campo] ?? "").localeCompare(
                String(b[campo] ?? ""),
                "pt-BR",
                { numeric: true }
              ) * direcao
          );

          const total = destinos.length;
          const inicio = Number(query.get("$skip") || 0);
          const quantidade = Number(query.get("$top") || total);
          return Promise.resolve({
            value: destinos.slice(inicio, inicio + quantidade),
            "@odata.count": total,
          });
        },
        (error) => Promise.reject(error.response.data)
      );
    },
    getAgentesWeb() {
      return GwayAgenteService.getAgentesWeb().then(
        (response) => Promise.resolve(response.Data || []),
        (error) => Promise.reject(error.response.data)
      );
    },
    desvincularAgente(context, guid) {
      return GwayAgenteService.desvincularAgente(guid).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response.data)
      );
    },
    desvincularDestino({ commit }, id) {
      return GwayAgenteService.desvincularDestino(id).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response.data)
      );
    },
    desvincularDestinoFixo({ commit }, destino) {
      return GwayAgenteService.desvincularDestinoFixo(
        destino.modulo,
        destino.codigo
      ).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response.data)
      );
    },
    testarImpressao({ commit }, id) {
      return GwayAgenteService.testarImpressao(id).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response.data)
      );
    },
    testarImpressaoDestinoFixo({ commit }, destino) {
      return GwayAgenteService.testarImpressaoDestinoFixo(
        destino.modulo,
        destino.codigo
      ).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response.data)
      );
    },
  },
  mutations: {},
};

export default gwayAgente;
